var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.758,
    height: 28,
    viewBox: "0 0 110.758 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(-483.624 -342.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M571.189,352.321H576.1c2.085,0,3.879,0,5.726,1.557a6.37,6.37,0,0,1,0,8.971c-1.847,1.557-3.641,1.557-5.726,1.557H574.8v7.441h-3.615Zm3.615,8.708h1.161c1.557,0,4.09-.106,4.09-2.665s-2.48-2.665-3.958-2.665H574.8Z",
    transform: "translate(-48.69 -5.307)",
    fill: "#00aec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M674.588,352.321h5.99a7.043,7.043,0,0,1,4.749,1.319,6.042,6.042,0,0,1,2.3,4.723,6.8,6.8,0,0,1-1.873,4.67,6.315,6.315,0,0,1-3.245,1.61l5.3,7.2h-4.38l-5.172-7.467H678.2v7.467h-3.615Zm3.615,9.341h2.322c2.982,0,3.483-1.979,3.483-3.008,0-1.082-.66-2.955-3.483-2.955H678.2Z",
    transform: "translate(-106.184 -5.307)",
    fill: "#00aec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M712.231,355.7h-3.615V352.32h10.871V355.7h-3.641v16.149h-3.615Z",
    transform: "translate(-125.105 -5.307)",
    fill: "#00aec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M618.931,342.777a14,14,0,1,1-14.073,14.073,14.037,14.037,0,0,1,14.073-14.073m0,23.346a9.349,9.349,0,1,0-9.091-9.309,9.235,9.235,0,0,0,9.091,9.309",
    transform: "translate(-67.411)",
    fill: "#00aec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M635.221,367.687a5.289,5.289,0,1,1-5.289-5.289,5.289,5.289,0,0,1,5.289,5.289",
    transform: "translate(-78.412 -10.91)",
    fill: "#00aec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M497.469,362.24h3.6c2.038,0,2.8.312,3.391.8a3.742,3.742,0,0,1,1.294,2.915,3.973,3.973,0,0,1-1.16,2.885,4.3,4.3,0,0,1-3.213.952h-1.22v3.45h-2.692Zm2.692,5.086h1.145c.535,0,1.755,0,1.755-1.324,0-1.294-1.249-1.294-1.859-1.294h-1.041Z",
    transform: "translate(-7.698 -10.822)",
    fill: "#00aec4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 2.811,
    height: 11.006,
    transform: "translate(499.527 351.417)",
    fill: "#00aec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M531.866,364.708h-2.171v-2.469h7.139v2.469h-2.156v8.537h-2.811Z",
    transform: "translate(-25.617 -10.822)",
    fill: "#00aec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M516.634,371.7h-33.01V352.539h33.01Zm-30.346-2.664H513.97V355.2H486.288Z",
    transform: "translate(0 -5.428)",
    fill: "#00aec4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8bca5add447d59b00130790b902c0110.svg";
export { ForwardRef as ReactComponent };